import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageTemplateComponent } from './page-template/page-template.component';
import { HeaderComponent } from './page-template/header/header.component';
import { MainComponent } from './page-template/main/main.component';
import { FooterComponent } from './page-template/footer/footer.component';
import { AppRoutingModule } from '../app-routing.module';
import { SharedModule } from '../shared/shared.module';
import { PosWarningsComponent } from '../modal/pos-warnings/pos-warnings.component';
import { DirectivesModule } from '../directives/directives.module';
import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';
@NgModule({
  declarations: [
    PageTemplateComponent,
    HeaderComponent,
    MainComponent,
    FooterComponent,
    PosWarningsComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    SharedModule,
    DirectivesModule,
    NgbPaginationModule,
  ],
  exports: [PageTemplateComponent, PosWarningsComponent],
})
export class LayoutModule {}
